/**
 * @file 摇号 - 基本信息
 */
import { ButtonAdd, Modal } from '@seiue/ui'
import { Form, Input } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Batch, BatchReq } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'

import { BasicInfoProps } from '../types'

import { BatchBox } from './BatchBox'
import { EditOpenContent } from './EditOpenContent'

/**
 * 摇号 - 基本信息
 *
 * @param param0 - 参数
 * @param param0.form - 表单实例
 * @param param0.setTitle - 设置标题
 * @param param0.initBatchs - 初始结果
 * @returns  component
 */
export const BasicInfo: React.FC<
  BasicInfoProps & {
    initBatchs: BatchReq[]
    openTypeDisabled?: boolean
  }
> = ({ form, setTitle, initBatchs }) => {
  const [batchs, setBatchs] = useState<BatchReq[]>(initBatchs)
  useEffect(() => {
    if (form !== undefined) {
      form.setFieldValue('batchs', batchs)
    }
  }, [form, batchs])

  return (
    <Wrapper>
      <Form
        colon={false}
        form={form}
        wrapperCol={{ span: 22 }}
        labelCol={{ span: 2 }}
        initialValues={{
          isShow: true,
        }}
      >
        <Form.Item
          label="摇号标题"
          name="name"
          rules={[{ required: true, message: '请输入摇号标题' }]}
        >
          <Input
            placeholder="请输入摇号标题"
            onChange={(e) => {
              setTitle && setTitle(e.target.value)
            }}
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="摇号批次"
          name="batchs"
          required={true}
          rules={[{ required: true, message: '摇号批次不能为空' }]}
        >
          {batchs.length > 0 ? (
            <BatchBoxs>
              {batchs.map((batch, key) => {
                return (
                  <BatchBox
                    setBatchs={setBatchs}
                    batchs={batchs}
                    key={key}
                    batchIndex={key}
                    batch={batch as Batch}
                  />
                )
              })}
            </BatchBoxs>
          ) : null}
          <ButtonAdd
            onClick={() => {
              const { hide } = Modal.open({
                width: 640,
                footer: null,
                bodyStyle: {
                  padding: '0',
                },
                title: '添加摇号批次',
                children: (
                  <EditOpenContent
                    hide={() => hide()}
                    setBatchs={setBatchs}
                    batchs={batchs}
                    outForm={form}
                  />
                ),
              })
            }}
          >
            添加摇号批次
          </ButtonAdd>
        </Form.Item>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled(EntryComponentsWrapper)`
  &&& {
    .ant-form-item-label {
      margin-right: 12px;
    }
    .se-button__link {
      font-weight: 400;
      color: ${(props) => props.theme.brand._1};
    }
  }
`

const BatchBoxs = styled.div`
  min-height: 108px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
`
